<template>
  <div class="about">
    <el-collapse>
      <el-collapse-item title="網上交易述流程描" name="1">
        <div>
          先登錄帳戶，把藥品加入購物車，在購物車中確認信息，選擇付款方式：微信支付，餘額支付，線下支付，點擊確認付款，點擊後將替換微信支付頁面，直接減少餘額或聯繫客服
          提供線下支付憑證。
        </div>
      </el-collapse-item>
      <el-collapse-item title="消費者客戶服務聯繫資訊" name="2">
        <div>
          联系电话：00853 28313270
        </div>
        <div>
          地址：澳門电厂巷22號亨達大廈地下AJ座
        </div>
      </el-collapse-item>
      <el-collapse-item title="退貨、退款和交易取消政策" name="3">
        <div>
          取消訂單：當您的訂單完成付款後，相關訂單內容已經被商戶確認并发货，我們無法為您取消訂單內容。
        </div>
        <div>
          退貨： 當您的訂單一經發貨並已在運輸途中後，我們不提供退貨。
        </div>
        <div>
          退款：當您的訂單在發貨前，發現有任何問題，可以在訂單處發起退款申請或當您的訂單被執業藥師審核不通過，我們會直接更換。
        </div>
      </el-collapse-item>
      <el-collapse-item title="送貨政策" name="4">
        <div>
          （1）到店自提。
        </div>
        <div>
          （2）由商家用DHL等快遞郵寄。
        </div>
        <div>
          （3）藥品需自行提供資料清關。
        </div>
      </el-collapse-item>
      <el-collapse-item title="交易貨幣及支付方式（如銀聯、PayPal等）" name="5">
        <div>
          交易貨幣：人民幣
        </div>
        <div>
          支付方式：微信支付，余額支付，線下支付
        </div>
      </el-collapse-item>
      <el-collapse-item title="售後服務或糾紛處理方式" name="6">
        <div>
          售後服務或糾紛處理可通過公眾號聯繫客服或致電聯繫電話處理。
        </div>
      </el-collapse-item>
      <el-collapse-item title="保密聲明或隱私聲明政策" name="7">
        <div>
          五洲藥物國際貿易有限公司（以下簡稱為本公司或五洲藥物）根據任何使用本公司移動端及微信公眾號的人員的私隱權。我們會確保所收集的個人資料僅用於清關及資料審核，
          我們對個人資料進行保密，對提供的資質材料進行用完即毀，不用作一切商業行為。
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- Matomo Image Tracker-->
    <img
      src="https://piwik.sosyao.com/matomo.php?idsite=15&amp;rec=1"
      style="border:0"
      alt=""
    />
    <!-- End Matomo -->
  </div>
</template>

<script>
export default {
  name: "AboutAs"
};
</script>
<style lang="scss" scoped>
.about {
  padding: 0 5px;
  background: #fff;
}
</style>
